<script>
import GlobalFormsContentDisplay from './GlobalFormsContentDisplay'
import GlobalFormsContentEditor from './global-forms-content-editor'

import resoJson from '@assets/ALL-reso.json';

export default {
  props: ['item', 'mls_field_values'],
  components: { GlobalFormsContentDisplay, GlobalFormsContentEditor },
  data() {
    return {

      loading: true,
      page_tab: 0,
      lang: true,
      editing_content: {},

      fields_already_collected: [
        'StandardStatus',
        'PropertyType',
        'PropertySubType',
        'StreetNumber',
        'StreetDirPrefix',
        'StreetName',
        'StreetSuffix',
        'StreetDirSuffix',
        'UnitNumber',
        'Address',
        'City',
        'StateOrProvince',
        'CountyOrParish',
        'Country',
        'PostalCode',
        'Longitude',
        'Latitude',
        'ListPrice',
        'ListOfficeName',
        'ListAgentFullName',
        'ListOfficeEmail',
        'ListOfficePhone',
        'OwnerName',
        'OwnerEmail',
        'OwnerPhone',
        'Owners',
        'looking_to_buy',
        'is_realtor',
        'has_realtor',
        'referred_by',
        'referred_name',
        'MailingAddress',
        'MailingCity',
        'MailingStateOrProvince',
        'MailingPostalCode',
      ],

      fields_used_on_map: [
        'ListingId',
        'StandardStatus',
        'PropertyType',
        'PropertySubType',
        'StreetNumber',
        'StreetDirPrefix',
        'StreetName',
        'StreetDirSuffix',
        'StreetSuffix',
        'UnitNumber',
        'Address',
        'City',
        'StateOrProvince',
        'CountyOrParish',
        'Country',
        'PostalCode',
        'Longitude',
        'Latitude',
        'ListingContractDate',
        'CloseDate',
        'ListPrice',
        'ClosePrice',
        'Ownership',
        'YearBuilt',
        'SeniorCommunityYN',
        'AssociationYN',
        'WaterSource',
        'Electric',
        'Sewer',
        'LivingArea',
        'LotSizeSquareFeet',
        'LotSizeAcres',
        'BedroomsTotal',
        'BathroomsFull',
        'BathroomsHalf',
        'BathroomsOneQuarter',
        'BathroomsPartial',
        'BathroomsThreeQuarter',
        'BathroomsTotalInteger',
        'Stories',
        'GarageSpaces',
        'ParkingTotal',
        'PoolFeatures',
        'View',
        'Heating',
        'Cooling',
        'Basement',
        'PublicRemarks',
        'Directions',
        'CrossStreet',
        'SubdivisionName',
        'ListOfficeName',
        'ListAgentFullName',
        'ListOfficeEmail',
        'ListOfficePhone',
        'PhotosCount',
        'thumbnail',
        'images',
      ],

      fields_auto_populated: [
        'ArchitecturalStyle',
        'YearBuilt',
        'Stories',
        'Heating',
        'Cooling',
        'FoundationDetails',
        'FireplaceFeatures',
        'WaterSource',
        'Sewer',
        'BedroomsTotal',
        'BathroomsTotalInteger',
        'BathroomsFull',
        'BathroomsOneQuarter',
        'BathroomsHalf',
        'BathroomsThreeQuarter',
        'Longitude',
        'Latitude',
        'GarageSpaces',
        'PoolFeatures',
        'LivingArea',
        'LotSizeAcres',
        'LotSizeSquareFeet',
        'apn',
        'zillowID',
        'parcelID',
        'taxCounty',
        'taxCountyID',
        'landUseCode',
        'landUseDescription',
        'landUseGeneral',
        'zoningCode',
        'zoningDescription',
        'TaxLegalDescription',
        'TaxLot',
        'SubdivisionName',
        'Township',
        'TaxTract',
      ],

      default_new_section: {
        FieldType: 'reso',
        Title: '',
        StandardName: '',
        Definition: '',
        SpanishStandardName: '',
        Synonym: [],
        SimpleDataType: '',
        PropertyTypes: ['RESI', 'LAND'],
        SugMaxPrecision: '',
        AutoPopulate: false,
        Hidden: false,
        Required: false,
        Disabled: false,
        Default: '',
        Options: [],
        Conditional: [],
        col_lg: '6',
        col_sm: '12',
        align: 'left',
      },
      new_section: {},

      reso_dictionary: [],

      default_mls_fields: [
        {
          title: 'Interior details',
          content: []
        },
        {
          title: 'Exterior details',
          content: []
        },
      ],

    }
  },
  computed: {
    tab_count: function() {
      var results = {}, total = 7;
      for(var page in this.item.form_fields) {
        results[page] = total;
        total++;
      }
      total = total + 6
      results['total'] = total;
      return results;
    },
  },
  created() {
    if(!this.item.form_fields) { this.item.form_fields = this.default_mls_fields; }
    this.new_section = JSON.parse(JSON.stringify(this.default_new_section));
    this.reso_dictionary = resoJson;

    var changes = false;
    for(var page_i in this.item.form_fields) {
      for(var field_i in this.item.form_fields[page_i].content) {
        for(var default_field in this.default_new_section) {
          if(typeof this.item.form_fields[page_i].content[field_i][default_field] == "undefined") {
            this.item.form_fields[page_i].content[field_i][default_field] = this.default_new_section[default_field];
            changes = true;
          }
        }
      }
    }
    if(changes) { this.$noty.warning('New field options have been updated. You may need to "Save changes" and refresh the page to prevent issues.'); }

  },
  methods: {
    add_content(page_i) {
      if(this.new_section.FieldType == 'reso' && typeof this.new_section.StandardName === 'object') {
        var temp = JSON.parse(JSON.stringify(this.new_section.StandardName));
        for(var i in temp) { this.new_section[i] = temp[i]; }
        this.new_section.StandardName = temp.StandardName;
      }
      if(this.new_section.FieldType == 'widget') { this.new_section.col_lg = '12'; this.new_section.col_sm = '12'; }

      this.item.form_fields[page_i].content.push(this.new_section);
      this.new_section = JSON.parse(JSON.stringify(this.default_new_section));
    },
    delete_content(page_i, content_i) {
      if(!this.item.form_fields[page_i].content[content_i]) { this.$noty.warning('ID not found'); return; }
      var n = this.$noty.error('<div>Are you sure you want to delete this content? This action cannot be undone.</div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light', res => {
            this.item.form_fields[page_i].content.splice(content_i, 1);
            this.$noty.success("Content removed");
            n.close();
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { });
    },
    delete_page(page_i) {
      if(!this.item.form_fields[page_i]) { this.$noty.warning('ID not found'); return; }
      var n = this.$noty.error('<div>Are you sure you want to delete this page? This action cannot be undone.</div>', { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-light', res => {
            this.item.form_fields.splice(page_i, 1);
            this.$noty.success("Page removed");
            n.close();
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { });
    },
  }
}
</script>


<template>

  <div class="">
    <b-modal ref="modal_edit_content" centered size="lg" title="Edit content" :hide-footer="true" :no-enforce-focus="true">
      <b-form @submit.prevent="">
        <div class="p-3">
          <global-forms-content-editor :item="editing_content" :mls_field_values="mls_field_values"></global-forms-content-editor>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-light" @click="$refs.modal_edit_content.hide()">Close</button>
        </footer>
      </b-form>
    </b-modal>

    <div class="row mx-0 border rounded">
      <div class="col-sm-12 col-md-12 col-lg-3 col-xl-2 p-0 bg-dark text-white small">
        <div class="nav flex-column">
          <div class="bg-gray-900 p-1 border-bottom border-black">
            <div class="input-group input-group-sm p-1">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Submit your listing" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Property address" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="List price" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Packages and services" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Additional details" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Submit your listing" disabled>
            </div>

            <div class="input-group input-group-sm p-1">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Enter property details" disabled>
            </div>

            <draggable handle=".handle" v-bind="{animation: 200}" v-model="item.form_fields" class="">
              <transition-group class="">
                <div v-for="(page, page_i) in item.form_fields" :key="'p'+page_i" class="">
                  <div class="input-group input-group-sm px-1 pb-1 pl-3">
                    <input type="text" class="form-control form-control-sm bg-dark border-black text-white" placeholder="Page title..." v-model="page.title" v-tippy content="Page title">
                    <div class="input-group-append">
                      <button class="btn btn-sm btn-dark border-black px-1" :class="page_tab == page_i ? 'text-primary' : 'text-white'" type="button" v-tippy content="View/edit page content" @click="page_tab = page_i"><Icon icon="ri:edit-2-line" /></button>
                      <button class="btn btn-sm btn-dark border-black px-1" type="button" v-tippy content="Delete page" @click="delete_page(page_i)"><Icon icon="ri:delete-bin-7-line" /></button>
                      <button class="btn btn-sm btn-dark border-black px-1 handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill" /></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            
            <div class="text-right px-1 pb-1 pt-0">
              <button class="btn btn-sm btn-primary" type="button" v-tippy content="Add page" @click="item.form_fields.push({title:'',content:[]})"><Icon icon="ri:add-line" /> Add page</button>
            </div>
            <div class="input-group input-group-sm p-1">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Property photos" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Upload property photos" disabled>
            </div>
            <div class="input-group input-group-sm p-1">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Document signatures" disabled>
            </div>
            <div class="input-group input-group-sm px-1 pb-1 pl-3">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Sign documents" disabled>
            </div>
            <div class="input-group input-group-sm p-1">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Listing is live" disabled>
            </div>
            <div class="input-group input-group-sm p-1">
              <input type="text" class="form-control form-control-sm bg-dark border-black text-gray-600" value="Listing is complete" disabled>
            </div>
          </div>

          <div class="p-2">
            <button class="btn btn-block btn-sm btn-success" type="button" v-tippy content="Save all changes to the form pages and content" @click="$emit('update_mls');"><Icon icon="ri:save-line" /> Save changes</button>
          </div>

        </div>
      </div>
      <div class="col-md bg-white">
        <div class="py-2 border-bottom">
          <ul class="list-inline m-0 float-right">
            <li class="list-inline-item d-block d-md-inline-block m_f-right">
              <button type="button" :class="'btn btn-sm btn-'+website_id" v-tippy content="Purchase upgrades"><Icon icon="mdi:gift-outline" width="16" /> Purchase upgrades</button>
            </li>
            <li class="list-inline-item d-block d-md-inline-block m_f-right">
              <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" v-tippy content="Preview listing"><Icon icon="ri:image-line" width="25" /></a>
            </li>
            <li class="list-inline-item d-block d-md-inline-block m_f-right">
              <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" v-tippy content="View order history"><Icon icon="mdi:clipboard-text-clock-outline" width="25" /></a>
            </li>
            <li class="list-inline-item d-block d-md-inline-block m_f-right dropdown dropdown-hover">
              <div class="">
                <a class="nav-link p-2 ml-2 text-gray-800 text-hover-black" href="" role="button" data-toggle="dropdown" v-tippy content="Help"><Icon icon="mdi:tooltip-question-outline" width="25" /></a>
                <div class="dropdown-menu dropdown-menu-right _w-n-300">
                  <div class="dropdown-item bg-light py-2"><h5 class="m-0">Email us:</h5></div>
                  <div class="dropdown-item py-2 text-muted">{{  app_email  }}</div>
                  <div class="dropdown-item bg-light py-2"><h5 class="m-0">Call us:</h5></div>
                  <div class="dropdown-item py-2 text-muted">{{ app_phone }}</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="list-inline m-0 float-left">
            <li class="list-inline-item d-block d-md-inline-block align-middle"><img :src="formatImage('/fm/revinre-nc/clip art/Real Estate Listings.png')" alt="" class="_w-35"></li>
            <li class="list-inline-item d-block d-md-inline-block align-middle small">
              <h5 class="m-0">{{ app_address }}</h5>
              <small>{{ app_city }}, {{ app_state }} {{ app_zip_code }}</small>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>

        <div class="progress _h-5"><div class="progress-bar progress-bar-striped progress-bar-animated bg-warning" :style="'width:'+Math.round((tab_count[page_tab])/tab_count['total']*100)+'%'"></div></div>

        <div class="text-right">
          <toggle-button class="my-2" v-model="lang" :width="95" :labels="{checked: 'English', unchecked: 'Spanish'}" :color="{checked: '#3BAFDA', unchecked: '#DA623B'}" />
        </div>

        <div v-for="(page, page_i) in item.form_fields" :key="'p'+page_i" v-if="page_tab == page_i">

          <draggable handle=".handle" v-bind="{animation: 200}" :force-fallback="true" v-model="page.content">
            <transition-group tag="div" class="row _w-m-1000 mx-auto">
              <div v-for="(content, content_i) in page.content" :key="'c'+content_i" :class="'mb-4 col-'+(content.col_sm ? content.col_sm : '12')+' col-sm-'+(content.col_lg ? content.col_lg : '12')+' text-'+(content.align ? content.align : 'left')">

                <div class="border border-light _b-dashed rounded">
                  <div class="bg-lighten-blue p-1">
                    <div class="float-right">
                      <button type="button" class="btn btn-sm btn-white ml-1" @click="editing_content = content; $refs.modal_edit_content.show()"><Icon icon="ri:edit-2-line" /></button>
                      <button type="button" class="btn btn-sm btn-white ml-1" v-tippy content="Click to delete" @click="delete_content(page_i, content_i)"><Icon icon="ri:delete-bin-7-line" /></button>
                      <button type="button" class="btn btn-sm btn-white ml-1 handle" v-tippy content="Drag to rearrange"><Icon icon="ri:drag-move-2-fill" /></button>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="p-1">
                    <GlobalFormsContentDisplay :content="content" :mls_field_values="mls_field_values" :lang="lang"></GlobalFormsContentDisplay>
                  </div>
                </div>

              </div>
            </transition-group>
          </draggable>

          <div class="row _w-m-1000 mx-auto py-3">
            <div class="col-6">
              <button v-if="page_tab > 0" type="button" class="btn btn-lg btn-success" @click="page_tab = page_tab - 1"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
            </div>
            <div class="col-6 text-right">
              <button v-if="item.form_fields.length && page_tab + 1 < item.form_fields.length" type="button" class="btn btn-lg btn-success" @click="page_tab = page_tab + 1">Next <Icon icon="ri:arrow-right-double-fill" /></button>
            </div>
          </div>

          <hr class="my-5 border-gray-400">
          <b-form @submit.prevent="add_content(page_i)" class="_w-m-1000 mb-4 mx-auto">
            <h5>Add Content</h5>
            <div class="mb-1">
              <select class="form-control" v-model="new_section.FieldType" v-tippy content="Content type">
                <option value="reso">RESO Input Field</option>
                <option value="custom">Custom Input Field</option>
                <option value="html">HTML Content</option>
              </select>
            </div>
            <div v-if="new_section.FieldType == 'reso'" class="mb-1">
              <multiselect v-model="new_section.StandardName" :options="reso_dictionary" :preserve-search="true" placeholder="Select..." label="Title" track-by="StandardName" v-tippy content="RESO input field">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title" :class="mls_field_values[props.option.StandardName] && mls_field_values[props.option.StandardName].used > 0 ? mls_field_values[props.option.StandardName].used == 1 ? 'text-success' : 'text-danger' : ''">{{props.option.Title}}
                      <span v-if="mls_field_values[props.option.StandardName]">
                        <span v-if="mls_field_values[props.option.StandardName].used == 1" class="text-success small font-weight-bold">(In Use)</span>
                        <span v-else-if="mls_field_values[props.option.StandardName].used > 1" class="text-danger small font-weight-bold">(In Use x{{mls_field_values[props.option.StandardName].used}})</span>
                      </span>
                    </span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="">
              <button type="submit" class="btn btn-block btn-success" v-tippy content="Add content"><Icon icon="ri:add-line" /> Add content</button>
            </div>
          </b-form>
        </div>

      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="card-box p-0 mb-3">

          <div class="p-4 small">
            <h4>Listing data ID output</h4>
            <p class="mb-3 text-muted">Below is an output of every possible data ID of a listing to be used for PDF auto fill and/or website map display. Data ID's can be used on uploaded PDF files to populate field data.</p>
            <ul class="m-0 pl-3 small">
              <li><strong>Data ID : </strong> A list of every data ID that already exists or has been added in the form editor above.</li>
              <li><strong>Used on map : </strong> Whether or not the data is used on the buyers map page on the client website.</li>
              <li><strong>Public data autofill : </strong> Whether or not the field has a chance of being autopopulated when the listing is submitted.</li>
              <li><strong>Already collected : </strong> Whether or not the field was already used on the initial part of the listing forms.</li>
              <li><strong>Used in form : </strong> Wheter or not the field exists in the form editor above.</li>
              <li><strong>Times collected : </strong> Number of times the field has been used. This should never be over 1.</li>
            </ul>
          </div>

          <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
              <thead class="bg-light">
                <tr>
                  <th>Data ID's</th>
                  <th>Used on map</th>
                  <th>Public data autofill</th>
                  <th>Already collected</th>
                  <th>Used in form</th>
                  <th>Times collected</th>
                </tr>
                <tr class="sticky-thead bg-light">
                  <th>Data ID's</th>
                  <th>Used on map</th>
                  <th>Public data autofill</th>
                  <th>Already collected</th>
                  <th>Used in form</th>
                  <th>Times collected</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tableitem, tableitem_i) in mls_field_values" :key="tableitem_i" >
                  <td class="py-1 px-3 font-weight-bold">{{tableitem_i}}</td>
                  <td class="py-1 px-3" :class="fields_used_on_map.includes(tableitem_i) ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ fields_used_on_map.includes(tableitem_i) ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3" :class="fields_auto_populated.includes(tableitem_i) ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ fields_auto_populated.includes(tableitem_i) ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3" :class="fields_already_collected.includes(tableitem_i) ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ fields_already_collected.includes(tableitem_i) ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3" :class="tableitem.used > 0 ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ tableitem.used > 0 ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3" :class="(fields_already_collected.includes(tableitem_i) ? tableitem.used+1 : tableitem.used) > 1 ? 'bg-lighten-danger' : (fields_already_collected.includes(tableitem_i) ? tableitem.used+1 : tableitem.used) == 1 ? 'bg-lighten-success' : ''">{{ fields_already_collected.includes(tableitem_i) ? tableitem.used+1 : tableitem.used > 0 ? tableitem.used : '' }}</td>
                </tr>
                <tr v-for="(tableitem, tableitem_i) in fields_auto_populated" :key="tableitem_i" v-if="!mls_field_values[tableitem]">
                  <td class="py-1 px-3 font-weight-bold">{{ tableitem }}</td>
                  <td class="py-1 px-3" :class="fields_used_on_map.includes(tableitem) ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ fields_used_on_map.includes(tableitem) ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3 bg-lighten-success">Yes</td>
                  <td class="py-1 px-3" :class="fields_already_collected.includes(tableitem) ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ fields_already_collected.includes(tableitem) ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3" :class="mls_field_values[tableitem] && mls_field_values[tableitem].used > 0 ? 'bg-lighten-success' : 'bg-lighten-danger'">{{ mls_field_values[tableitem] && mls_field_values[tableitem].used > 0 ? 'Yes' : 'No' }}</td>
                  <td class="py-1 px-3" :class="fields_already_collected.includes(tableitem) ? 'bg-lighten-success' : ''">{{ fields_already_collected.includes(tableitem) ? 1 : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
